import {z} from 'src/lib'
import {OperacionCorporateLendingDetalleFields, OperacionCorporateLendingFields } from './fields';
import {schemaEntityWithId} from "../../../../../types";
import {OperacionContraparteFields} from "../../contraparte/types/fields";
import {OperacionCapitalMarketsFields} from "../../capital_markets/types/fields";


export const schemaOperacionCorporateLending = z.object({
  [OperacionCorporateLendingFields.CodPais]: z.number(),
  [OperacionCorporateLendingFields.NombrePais]: z.string(),
  [OperacionCorporateLendingFields.CodOperacionCorporateLendingEstado]: z.number(),
  [OperacionCorporateLendingFields.DescOperacionCorporateLendingEstado]: z.string(),
  [OperacionCorporateLendingFields.FechaEmision]: z.coerce.date().nullable(),
  [OperacionCorporateLendingFields.FechaVencimiento]: z.coerce.date(),
  [OperacionCorporateLendingFields.Observaciones]: z.string(),
  [OperacionCorporateLendingFields.FechaAlta]: z.coerce.date().nullable(),
  [OperacionCorporateLendingFields.IdUsuarioAlta]: z.number(),
  [OperacionCorporateLendingFields.NombreUsuarioAlta]: z.string(),
  [OperacionCorporateLendingFields.ApellidoUsuarioAlta]: z.string(),
  [OperacionCorporateLendingFields.MailUsuarioAlta]: z.string(),
  [OperacionCorporateLendingFields.EstadoFinalizado]: z.boolean(),
  [OperacionCorporateLendingFields.Envio]: z.boolean(),
  [OperacionCorporateLendingFields.IdMensaje]: z.number().nullable(),
  [OperacionCorporateLendingFields.PermiteEditarOperacion]: z.boolean(),
  [OperacionCorporateLendingFields.PermiteEliminarOperacion]: z.boolean(),
}).merge(schemaEntityWithId);

export type OperacionCorporateLending = z.infer<typeof schemaOperacionCorporateLending>

export const schemaOperacionCorporateLendingDetalle = z.object({
  [OperacionCorporateLendingDetalleFields.IdOperacionCorporateLending]: z.number(),
  [OperacionCorporateLendingDetalleFields.Deudor]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Acreedor]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Moneda]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Monto]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Destino]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.PlazoDisponibilidad]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Plazo]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Amortizacion]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Comision]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Precancelacion]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.TasaInteres]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.FrecuenciaInteres]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.FiadorAvalista]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Garantias]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Pagare]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Covenants]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Ley]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.FechaEjecucion]: z.coerce.date().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.FechaAlta]: z.coerce.date().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.IdUsuarioAlta]: z.number().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.FechaUltMod]: z.coerce.date().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.IdUsuarioUltMod]: z.number().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Activo]: z.boolean().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.PermiteEditar]: z.boolean().optional().nullable(),
}).merge(schemaEntityWithId);

export type OperacionCorporateLendingDetalle = z.infer<typeof schemaOperacionCorporateLendingDetalle>

export const schemaFormOperacionCorporateLendingDetalle =  z.object({
  [OperacionCorporateLendingDetalleFields.Deudor]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Acreedor]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Moneda]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Monto]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Destino]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.PlazoDisponibilidad]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Plazo]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Amortizacion]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Comision]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Precancelacion]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.TasaInteres]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.FrecuenciaInteres]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.FiadorAvalista]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Garantias]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Pagare]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Covenants]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.Ley]: z.string().optional().nullable(),
  [OperacionCorporateLendingDetalleFields.FechaEjecucion]: z.coerce.date().optional().nullable(),
}).merge(schemaEntityWithId);

export type FormOperacionCorporateLendingDetalle = z.infer<typeof schemaFormOperacionCorporateLendingDetalle>

export const schemaFormOperacionCorporateLending = z
  .object({
    [OperacionCapitalMarketsFields.CodPais]: z.number(),
    [OperacionCorporateLendingFields.FechaVencimiento]: z.date(),
    [OperacionCorporateLendingFields.Observaciones]: z.string().nullable().optional(),
  })


export type FormOperacionCorporateLending = z.infer<typeof schemaFormOperacionCorporateLending>